import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { useAuthStore } from '@/stores/useAuthStore';

export const authGuard = async (
  _to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  const isMockAuth = import.meta.env.VITE_MOCK_AUTH === 'true';
  const authStore = useAuthStore();

  if (!isMockAuth) {
    authStore.loadUserInfo();

    if (!authStore.isAuthenticated) {
      await authStore.refreshTokenOrLogin();
    }
  }

  next();
};
